import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage';

import { ModalController } from '@ionic/angular';

import { SERVICE } from './NeurConstants';

@Injectable()
class UserService {
    public user_info = null;
    private user_infobase;
    private _modal_opened = false;
    
    constructor(private storage: Storage, private modalController:ModalController) {}

    public async load_user_infobase() {
        this.user_infobase = await this.storage.get(SERVICE.USER_INFO_STORAGE);
        if (!this.user_infobase) {
            this.user_infobase = {
                active_user: -1,
                user_info: new Map()
            };
        }
    }

    public async save_user_infobase() {
        
        await this.storage.set(SERVICE.USER_INFO_STORAGE, this.user_infobase);
    }

    public setUserInfo(user_info) {
        this.user_infobase.user_info.set(user_info._id, user_info);
    }

    public getUserInfo(user_id) {
        return this.user_infobase.user_info.get(user_id);
    }

    public async setActiveUser(user_id) {
        this.user_infobase.active_user = user_id;
        this.user_info = this.getUserInfo(user_id);
        await this.storage.set(SERVICE.USER_INFO_STORAGE,this.user_infobase);
    }
    public getActiveUser() {
        return this.user_infobase.active_user;
    }

    public openSettingsModal(settings) {
        if (!this._modal_opened) {
            this._modal_opened = true;
            this.modalController.create({
                    component: settings,
                    cssClass: 'settings_modal',
                    componentProps: {},
                    showBackdrop: false,
                })
                .then(modal => {
                    modal.present();
                    modal.onDidDismiss().then((dataReturned) => {
                        if (dataReturned != null) {
                            if (dataReturned.data) {
                                ;
                            }
                        }
                        //TBD if changes
                        if (true){
                            this.storage.set(SERVICE.USER_INFO_STORAGE,this.user_infobase);
                        }
                        this._modal_opened = false;
                        // console.log(dataReturned.data);
                    });
                });
        }
    }

}

/*
    Service class should be exported as ExportedClass
*/
export {
    UserService as ExportedClass
};